export default "__VITE_ASSET__5cKE89Fg__"